import * as React from "react";

import { useGiftcardBalance } from "../providers";

import { OldLoading } from "../old-loading";

import { AccessForm } from "./access-form";
import { ViewBalance } from "./view-balance";

export const CheckBalancePage: React.FunctionComponent = () => {
  const { isLoadingBalance, balanceDetails } = useGiftcardBalance();
  return (
    <div className="content check-balance-page">
      {balanceDetails ? <ViewBalance /> : <AccessForm />}
      
      {isLoadingBalance && <OldLoading />}
    </div>
  );
};
